import { useFormContext, useWatch } from "react-hook-form"
import { Checkbox } from "~/shadcn/ui/checkbox"
import { FormField, FormItem, FormMessage } from "~/shadcn/ui/form"
import { SearchValues } from "../../schema"
import { ExclusivityEnum } from "~/__generated__/graphql"
import { FilterLabel } from "~/ui/FilterLabel"

const FIELD_NAME = "exclusivities"

export const ExclusivityFilter = () => {
  const form = useFormContext<SearchValues>()

  const selectedExclusivities =
    useWatch({
      control: form.control,
      name: FIELD_NAME,
    }) || []

  const checked = selectedExclusivities.includes(ExclusivityEnum.Exclusive)
  const toggle = () => {
    form.setValue(FIELD_NAME, checked ? [] : [ExclusivityEnum.Exclusive])
  }

  return (
    <FormField
      control={form.control}
      name={FIELD_NAME}
      render={() => (
        <FormItem>
          <FilterLabel text="Exclusivity" />
          <div className="flex items-center space-x-2">
            <Checkbox
              id="exclusivity-only"
              checked={checked}
              onCheckedChange={toggle}
            />
            <label
              htmlFor="exclusivity-only"
              className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Show me only Exclusively represented influencers
            </label>
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
